import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';
import ObiettiviWizard from './ObiettiviWizard';

/* Icona "sliders" (configurazione priorità) — SVG, niente emoji */
function IconSliders({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="21" x2="4" y2="14" /><line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" /><line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" /><line x1="20" y1="12" x2="20" y2="3" />
      <line x1="1" y1="14" x2="7" y2="14" /><line x1="9" y1="8" x2="15" y2="8" /><line x1="17" y1="16" x2="23" y2="16" />
    </svg>
  );
}

/* Interruttore agente 456 condiviso (header + pagina Verifiche).
   - Accendere è immediato.
   - Spegnere chiede conferma con un dialog centrato; il backend completa
     la verifica in corso e poi si ferma (soft-stop). */
export default function AgentToggle({ compact = false }) {
  const [agentOn, setAgentOn] = useState(false);
  const [inAttesa, setInAttesa] = useState(false);
  const [toggling, setToggling] = useState(false);
  const [confirmOff, setConfirmOff] = useState(false);
  const [wizardOpen, setWizardOpen] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API}/agent/status`).then(r => {
      setAgentOn(!!r.data.attivo);
      setInAttesa(!!r.data.in_attesa);
    }).catch(() => {});
  }, []);
  useEffect(() => { load(); const id = setInterval(load, 4000); return () => clearInterval(id); }, [load]);

  const doToggle = async (next) => {
    setToggling(true);
    try {
      const r = await axios.post(`${API}/agent/toggle`, { attivo: next });
      setAgentOn(!!r.data.attivo);
      toast.success(r.data.attivo
        ? 'AI 456 attivato'
        : 'AI 456 in arresto — completa la verifica in corso, poi si ferma');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Errore');
    } finally {
      setToggling(false);
      setConfirmOff(false);
    }
  };

  const onClick = () => {
    if (agentOn) setConfirmOff(true);  // spegnere → conferma
    else doToggle(true);               // accendere → subito
  };

  return (
    <>
      <div className="agent-toggle-wrap">
        <button
          type="button"
          className={`agent-switch${agentOn ? ' on' : ''}${compact ? ' compact' : ''}${agentOn && inAttesa ? ' agente-attesa' : ''}`}
          onClick={onClick}
          disabled={toggling}
          title={agentOn ? 'Disattiva agente 456' : 'Attiva agente 456'}
        >
          <span className="agent-switch-track"><span className="agent-switch-knob" /></span>
          {!compact && <span className="agent-switch-lbl">AI {agentOn ? (inAttesa ? 'in attesa' : 'Attiva') : 'Spenta'}</span>}
        </button>
        {compact && agentOn && (
          <button type="button" className="agent-prio-btn" title="Obiettivi e priorità"
            onClick={() => setWizardOpen(true)}>
            <IconSliders />
          </button>
        )}
      </div>

      <ObiettiviWizard open={wizardOpen} onClose={() => setWizardOpen(false)} />

      {confirmOff && createPortal(
        <div className="confirm-overlay" onClick={() => !toggling && setConfirmOff(false)}>
          <div className="confirm-dialog" onClick={e => e.stopPropagation()}>
            <div className="confirm-title">Disattivare l'agente 456?</div>
            <div className="confirm-text">
              La verifica <b>attualmente in corso verrà completata</b>, poi l'agente si fermerà
              (non ne avvierà altre).
            </div>
            <div className="confirm-btns">
              <button className="btn btn-danger" disabled={toggling} onClick={() => doToggle(false)}>
                {toggling ? '…' : 'Sì'}
              </button>
              <button className="btn btn-secondary" disabled={toggling} onClick={() => setConfirmOff(false)}>
                No
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
